module.exports = __webpack_public_path__ + "img/IMG-20191212-WA0019.8feb9c33.jpg";